import { rusPassportCode } from '../../../../constants/constants';
import { checkNotEmpty } from '../../../../helpers/validators';
import { patternIssuerUnitCodeOther, patternIssuerUnitCodeRus } from './DocumentIssuerUnitCodeField.constants';
const checkIssuerUnitCodeFormat = ({ value, documentType, }) => {
    const pattern = documentType === rusPassportCode ? patternIssuerUnitCodeRus : patternIssuerUnitCodeOther;
    if (!pattern.test(value)) {
        return {
            message: 'Неверный формат',
            type: 'lostfocus',
        };
    }
    return null;
};
export const validateDocumentIssuerUnitCode = ({ value, required, documentType, }) => {
    if (required) {
        return checkNotEmpty({ value }) || checkIssuerUnitCodeFormat({ value, documentType });
    }
    return value ? checkIssuerUnitCodeFormat({ value, documentType }) : null;
};
